import { render, staticRenderFns } from "./BrandFilters.vue?vue&type=template&id=2ed5a4d2&"
import script from "./BrandFilters.vue?vue&type=script&lang=js&"
export * from "./BrandFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports